import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import useLogin from 'src/hooks/useLogin';
import useQueryWithAuth from 'src/hooks/useQueryWithAuth';
import { RestQueryOptions } from 'src/hooks/useRestQuery';
import { GemProductsResponse, GetGemProductsRequest } from 'src/types/Payments';
import { Platform } from 'src/types/Platform';
import { safeWindow } from 'src/utils/static-generation';

enum GemProductApiList {
  GetGemProducts = '/api/shop/gem-products',
}

export const GEM_PRODUCT_QUERY_KEYS = {
  getGemProducts: () => [GemProductApiList.GetGemProducts],
};

export const useGetGemProductsQuery = (options: RestQueryOptions<GemProductsResponse> = {}) => {
  const { isLogin } = useLogin();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (isLogin) {
      queryClient.invalidateQueries({ queryKey: GEM_PRODUCT_QUERY_KEYS.getGemProducts() });
    }
  }, [isLogin, queryClient]);

  return useQueryWithAuth<GetGemProductsRequest, GemProductsResponse, void>({
    path: GemProductApiList.GetGemProducts,
    queryKey: GEM_PRODUCT_QUERY_KEYS.getGemProducts(),
    params: {
      platform: safeWindow?.AzarJs?.getPlatform() || Platform.WebClient,
    },
    options: {
      gcTime: Infinity,
      staleTime: Infinity,
      ...options,
    },
  });
};
